<template>
  <node-view-wrapper class="editor-wrapper-std">
    <div class="label" contenteditable="false">Файл для скачивания</div>
    <div class="close" contenteditable="false" @click="removeNode">
      <v-icon>mdi-close</v-icon>
    </div>
    <div class="download-link">{{ node.attrs.src }}</div>
    <node-view-content class="content-dom" />
  </node-view-wrapper>
</template>

<script>
import { nodeViewProps, NodeViewWrapper, NodeViewContent } from "@tiptap/vue-2";

export default {
  components: {
    NodeViewWrapper,
    NodeViewContent
  },
  props: nodeViewProps,
  methods: {
    removeNode() {
      this.deleteNode();
    }
  }
};
</script>
<style scoped lang="scss">
.download-link {
  color: #aaa;
  user-select: none;
}
</style>
